import moment from 'moment';

/* */
export const getRegistrationStatus = ({ registration }) => {
  let status = 1;
  let statusText;

  let endAt;
  if (!registration.endTime) {
    endAt = moment(registration.endAt, 'YYYY-MM-DD').endOf('day');
  } else {
    endAt = moment(`${registration.endAt} ${registration.endTime}`, 'YYYY-MM-DD hh:mm');
  }

  const startAt = moment(registration.startAt, 'YYYY-MM-DD').startOf('day');

  if (endAt.isBefore()) {
    status = 0;
    statusText = 'Inscriptions closes';
  } else if (startAt.isAfter()) {
    status = 1;
    statusText = `Début des inscriptions le ${startAt.format('DD/MM/YYYY')}`;
  } else if (registration.open) {
    status = 2;
    if (endAt.dayOfYear() === moment().dayOfYear()) {
      statusText = 'Dernier jour d\'inscription';
      if (registration.endTime) {
        statusText = `${statusText}, jusqu'à ${registration.endTime}`;
      }
    } else {
      statusText = `Inscriptions ouvertes jusqu'au ${endAt.format('DD/MM/YYYY')}`;
      if (registration.endTime) {
        statusText = `${statusText} à ${registration.endTime}`;
      }
    }
    if (!registration.openOnline) {
      status = 3;
      statusText += " (uniquement à l'accueil)";
    }
  } else {
    status = 0;
    statusText = 'Inscriptions closes';
  }

  return { status, statusText };
};

/* */
export const isOpened = (tournament) => {
  const { status } = getRegistrationStatus(tournament);
  return status === 2;
};

/* */
export const getSeriesList = (results) => {
  const list = [];
  results.forEach((r) => !list.includes(r.series) && list.push(r.series));

  return list;
};

// DEPRECATED
export const getResultsByRank = (results) => (
  Object.values(results.reduce((acc, r) => {
    if (typeof acc[r.rank] === 'undefined') {
      acc[r.rank] = [];
    }
    acc[r.rank].push(r);

    return acc;
  }, {}))
);

export const reorderResults = (results) => {
  const resultsByStatusAndRank = results.reduce((acc, r) => {
    const key = r.status === '00' ? 'ok' : 'incomplete';
    if (acc[key][r.rank] === undefined) {
      acc[key][r.rank] = [];
    }
    acc[key][r.rank].push(r);

    return acc;
  }, { ok: {}, incomplete: {} });

  return [
    ...Object.values(resultsByStatusAndRank.ok),
    ...Object.values(resultsByStatusAndRank.incomplete),
  ];
};

export const reorderResultsWithoutRank = (results) => {
  const resultsByStatus = results.reduce((acc, r) => {
    const key = r.status === '00' ? 'ok' : 'incomplete';
    acc[key].push([r]);

    return acc;
  }, { ok: [], incomplete: [] });

  return [
    ...resultsByStatus.ok,
    ...resultsByStatus.incomplete,
  ];
};

/* */
export const getEntryStatus = (entries, licenseNumber) => {
  const entry = entries.find((e) => e.licenseNumber === licenseNumber);
  const partners = entries.reduce((acc, e) => {
    if (entry && e.partners.includes(entry.reference)) {
      acc.push(e);
    }

    return acc;
  }, []);

  return { entry, partners };
};

/* */
export const isEntered = (entries, licenseNumber) => {
  const { entry } = getEntryStatus(entries, licenseNumber);

  return Boolean(entry);
};
